export default __webpack_public_path__ + "static/featuresListItem11-f03d4904a800ab3404b296b5148189b5.svg";